export default __webpack_public_path__ + "static/media/whatis1.07a0c433.png";